'use strict';
var ClinicalUpdatesController = /** @class */ (function () {
    /*@ngInject*/
    function ClinicalUpdatesController(ClinicalUpdatesService, $scope, EducationSubNavService) {
        var _this = this;
        this.headerContent = "Are you looking to stay up-to-date on the latest industry news and research? As an Emerson customer you have complimentary access to a wide selection of online and print resources including our blog, research reviews from leading experts, and our customer favorite, The Element.";
        var blog = "";
        ClinicalUpdatesService.getBlog()
            .then(function (response) {
            blog = response.blog;
        });
        ClinicalUpdatesService.getClinicalUpdatesData()
            .then(function (response) {
            //TODO: The below mocked content has to be removed once we have API implemented
            var resp = {
                "response": [
                    {
                        "id": "update_blog",
                        "state_id": blog,
                        "title": "Blog",
                        "content": "Trending topics served up daily through the Emerson blog. See what's new today."
                    },
                    {
                        "id": "update_author",
                        "state_id": "clinicalUpdatesAuthors",
                        "title": "Emerson Authors",
                        "content": "Access research reviews from leading experts: Paul Anderson, NMD; Tori Hudson, ND; Alan Gaby, ND and more."
                    },
                    {
                        "id": "update_elements",
                        "state_id": "clinicalUpdatesElements",
                        "title": "Emerson Elements",
                        "content": "Our quarterly publication featuring news and research articles written by industry experts."
                    }
                ]
            };
            _this.clinicalUpdate = resp.response;
        });
        $scope.$ctrl.value.selectedpageindex = 3;
        $scope.$ctrl.value.level = '2';
        this.eduSubNavService = EducationSubNavService;
        this.eduSubNavService.level = '2';
    }
    return ClinicalUpdatesController;
}());
export default ClinicalUpdatesController;
//# sourceMappingURL=clinical-updates.controller.js.map